export const space = {
  auto: 'auto',
  none: '0px',
  xxxxs: '2px',
  xxxs: '4px',
  xxs: '8px',
  xs: '16px',
  s: '24px',
  m: '32px',
  l: '40px',
  xl: '48px',
  xxl: '56px',
  xxxl: '64px',
  huge: '96px',
  gridGutter: '12px',
  gridMargin: '24px',

  '-xxxxs': '-2px',
  '-xxxs': '-4px',
  '-xxs': '-8px',
  '-xs': '-16px',
  '-s': '-24px',
  '-m': '-32px',
  '-l': '-40px',
  '-xl': '-48px',
  '-xxl': '-56px',
  '-xxxl': '-64px',
  '-gridGutter': '-12px',
  '-gridMargin': '-24px',
};
